module.exports = __webpack_public_path__ + "img/experienceValue.2b97c66b.jpg";